// extracted by mini-css-extract-plugin
export default {"root":"IconFortehWeb_root__XYoJl"};